import Vue from 'vue';
import {
  alignForNumber,
  LinkCellRenderer,
  MultiLinkCellRenderer,
  autoResize,
  getPinnedRowData
} from '@/helpers/renderHelpers';
import {
  addColIdToColumns,
  handlerResponse,
  setNotifyData,
  SumRows
} from '@/helpers/commonHelpers';
import gridProps from '@/gridProps';

export default {
  namespaced: true,
  state: {
    requestItemsColumns: [],
    requestOrderColumns: [],
    requests: [],
    requestItems: [],
    pinnedRowData: [],
    requestItemsPinnedRowData: [],
    documents: [],
    comments: [],
    requestsCount: 0,
    gridOptions: {
      rowGroupPanelShow: 'always',
      animateRows: true,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true
      },
      aggFuncs: {
        'SumRows': SumRows
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        } else {
          this.api && this.api.hideOverlay();
          this.api && this.api.showNoRowsOverlay();
        }
      }
    },
    requestOrderGridOptions: {
      rowGroupPanelShow: 'always',
      animateRows: true,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true
      },
      aggFuncs: {
        'SumRows': SumRows
      },
      components: {
        'RequestOrderLink': LinkCellRenderer('id', '/requests/'),
        'BuyerLink': LinkCellRenderer('buyer_id', '/partners/'),
        'SupplierLink': LinkCellRenderer('shipper_id', '/partners/'),
        'SellerLink': LinkCellRenderer('seller_id', '/partners/'),
        'ContractsLink': MultiLinkCellRenderer('contracts', '/contracts/', 'contract_nr', 'id')
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        }
      }
    },
    gridName: ''
  },
  getters: {
    requestOrderGridOptions(state) {
      return {...state.requestOrderGridOptions, ...gridProps};
    },
    requestItemsGridOptions(state) {
      return {
        ...state.gridOptions,
        components: {
          'ContractLink': LinkCellRenderer('contract_id', '/contracts/'),
        },
        getRowStyle: function (params) {
          if (params.data && !params.data.twl_nominal && !params.node.rowPinned) {
            return {background: '#FCCEC4'}
          }
        },
      };
    }
  },
  mutations: {
    setRequestsData(state, data) {
      if (data.data) {
        state.requestOrderColumns = addColIdToColumns(data.used_columns);
        //adding unique keys for 'contract_nr' column. Needed for correct row grouping
        state.requestOrderColumns = state.requestOrderColumns.map(e => {
          if (e.field && e.field === 'contract_nr') {
            e.keyCreator = function (params) {
              if (params) {
                return params.value.map(e => e.id).join('');
              }
            }
          }
          return e
        });
        state.requests = data.data.results;
        state.requestsCount = data.data.count;
        state.pinnedRowData = getPinnedRowData(data.total, 'name', 'value')
      }
      else {
        state.requests = data;
        state.pinnedRowData = data;
      }
      if (data.grid_name) {
        state.gridName = data.grid_name;
      }
    },
    setRequestItemTotalData(state, data) {
      if (data.data) {
        state.requestItemsPinnedRowData = getPinnedRowData(data.total, 'name', 'value');
      }
      else {
        state.requestItemsPinnedRowData = data;
      }
    },
    setRequestItemData(state, data) {
      if (data.data) {
        state.requestItemsColumns = addColIdToColumns(data.used_columns);
        state.requestItems = data.data.results;
        state.requestItemsPinnedRowData = getPinnedRowData(data.total, 'name', 'value');
      }
      else {
        state.requestItems = data;
        state.requestItemsPinnedRowData = data;
      }
    },
    setCommentsList(state, data) {
      state.comments = data;
    },
    setDocumentsList(state, data) {
      state.documents = data;
    },
    setTotalByFilter(state, data) {
      state.pinnedRowData = getPinnedRowData(data.total, 'name', 'value')
    }
  },
  actions: {
    loadRequests(store, payLoad) {
      if (store.getters.requestOrderGridOptions.api) {
        store.getters.requestOrderGridOptions.api.showLoadingOverlay();
      }
      Vue.http.get('purchase/search_for_request_orders/', {params: payLoad})
        .then(response => response.json())
        .then(data => {
          store.commit('setRequestsData', data);
        });
    },
    updateTotalByFilter(store, payLoad) {
      if (store.getters.requestOrderGridOptions.api) {
        store.getters.requestOrderGridOptions.api.showLoadingOverlay();
      }
      Vue.http.get('purchase/search_for_request_orders/', {params: payLoad})
        .then(response => response.json())
        .then(data => {
          store.commit('setTotalByFilter', data);
        });
    },
    updateRequestItemsTotalData(store, payLoad) {
      Vue.http.get('purchase/request_items/', {params: payLoad})
        .then(response => response.json())
        .then(data => {
          store.commit('setRequestItemTotalData', data);
        });
    },
    loadRequestItems(store, payLoad) {
      Vue.http.get('purchase/request_items/', {params: payLoad})
        .then(response => response.json())
        .then(data => {
          store.commit('setRequestItemData', data);
        });
    },
    loadCommentsList(store, payLoad) {
      Vue.http.get(`purchase/request_orders/${payLoad.id}/comments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setCommentsList', data);
        });
    },
    loadDocumentsList(store, payLoad) {
      Vue.http.get(`purchase/request_orders/${payLoad.id}/attachments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setDocumentsList', data);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/purchases/requests/requests.js